import { useTranslation } from 'react-i18next'

import bgGoodstackBulletPoints from '@percent/cause-dashboard/common/assets/images/bg-goodstack-bullet-points.png'
import { ReactComponent as PlusIcon } from '@percent/cause-dashboard/common/assets/images/plus-icon.svg'
import { LocaleKey } from '@percent/cause-dashboard/i18n/config'
import { Flex, Typography } from '@percent/lemonade'
import styles from './TitleAndBullets.module.scss'

type TitleAndBulletsProps = {
  title: string
  bullets?: { title: LocaleKey }[]
  bulletElements?: JSX.Element[]
  noBackgroundImage?: boolean
  noSubtitle?: boolean
  noFixedWidth?: boolean
  customSubtitle?: string
  bulletAlign?: 'center' | 'start'
}

export function TitleAndBullets({
  title,
  bullets,
  bulletElements,
  noBackgroundImage,
  noSubtitle,
  customSubtitle,
  noFixedWidth,
  bulletAlign = 'center'
}: TitleAndBulletsProps) {
  const { t } = useTranslation()

  const backgroundImageStyle = noBackgroundImage ? undefined : { backgroundImage: `url(${bgGoodstackBulletPoints})` }

  return (
    <div className={styles.bgImageWrapper} style={backgroundImageStyle}>
      <Flex direction="column" className={styles.mainGrid} style={{ maxWidth: noFixedWidth ? '100%' : '464px' }}>
        <Typography className={styles.title} variant="h2">
          {title}
        </Typography>

        {customSubtitle && (
          <Typography variant="h4" className={styles.customSubtitle}>
            {customSubtitle}
          </Typography>
        )}

        {!noSubtitle && (
          <Typography variant="h4" className={styles.subTitle}>
            Our platform allows you to:
          </Typography>
        )}
        {bulletElements && (
          <Flex direction="column" gap={20}>
            {bulletElements.map((element, index) => (
              <Flex key={index} gap={12} align={bulletAlign}>
                <PlusIcon />
                <Typography variant="large">{element}</Typography>
              </Flex>
            ))}
          </Flex>
        )}
        {bullets && (
          <Flex direction="column" gap={20}>
            {bullets.map(({ title: bulletTitle }) => (
              <Flex key={bulletTitle} gap={12} align={bulletAlign}>
                <PlusIcon />
                <Typography variant="large">{t(bulletTitle)}</Typography>
              </Flex>
            ))}
          </Flex>
        )}
      </Flex>
    </div>
  )
}
